import styles from "@/styles/app.module.css";
import { HeadlineProps } from "@/types/ui-kit/ui";
import React, { useEffect, useState } from "react";
import { FollowButton } from "@/components/ui-kit/Buttons/FollowButton";
import { TinyDownloadButton } from "@/components/ui-kit/Buttons/TinyDownloadButton";
import { useOfflineIssueContent } from "@/hooks/indexeddb/useOfflineIssueContent";
import { ReadMoreLink } from "@/components/ui-kit/ReadMoreLink";
import { DottedSeparator } from "@/components/ui-kit/Decorations/DottedSeparator";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export const Headline: React.FC<HeadlineProps> = ({
  issue,
  title,
  description,
  displayFollowButton,
  displayDownloadButton,
  isListingTitle,
  ctaLink,
  descriptionUnderline,
  homePageHeadline,
  ctaGalleryLink,
  onDeleteAll,
  onSaveAll,
}) => {
  const { isDownloaded, saveOrDelete } = useOfflineIssueContent();
  const [isIssueDownloaded, setIsIssueDownloaded] = useState<boolean>(false);
  const isMobile = useMediaQuery(561);

  useEffect(() => {
    isDownloaded(issue?.id!).then((res) => {
      setIsIssueDownloaded(res);
    });
  }, [isDownloaded, issue?.id]);

  return (
    <header className="pb-[24px]">
      <div className={!homePageHeadline ? styles.contentContainer : ""}>
        <div className={!descriptionUnderline ? "border-b-2 border-orange pb-[12px]" : ""}>
          <div className="flex w-full items-center justify-between">
            <h2 className={isListingTitle ? styles.listingTitle : styles.headlineTitle}>{title}</h2>
            {!isMobile && (ctaLink || ctaGalleryLink) && (
              <ReadMoreLink
                href={ctaLink ? ctaLink.url : !!ctaGalleryLink ? ctaGalleryLink : ""}
                title={ctaLink ? ctaLink.title : !!ctaGalleryLink ? "Další fotogalerie" : ""}
                className="font-sans"
              />
            )}
            {displayFollowButton && <FollowButton onClick={() => console.log("clicked")} />}
            {displayDownloadButton && (
              <TinyDownloadButton
                onClick={() => saveOrDelete(issue!)}
                downloaded={isIssueDownloaded}
                downloading={false}
                short
                issuesTooltipTitle
                postTitle={issue?.title ?? "Magazín Reportér"}
              />
            )}
          </div>
        </div>
        {description && (
          <div className={descriptionUnderline ? "border-b-2 border-orange" : ""}>
            <p className={homePageHeadline && descriptionUnderline ? styles.headlineDesc : "pt-[12px]"}>
              {description}
            </p>
            {!homePageHeadline && <DottedSeparator />}
          </div>
        )}
      </div>
    </header>
  );
};
